import axios from 'axios';

const BASE_URL = process.env.REACT_APP_BACKEND_URL;
export const TOKEN_KEY = 'radius_jwt';

export const api = axios.create({
  baseURL: `${BASE_URL}/api`,
  timeout: 15000,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem(TOKEN_KEY);
  if (token) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export function apiErrorMessage(e) {
  const detail = e?.response?.data?.detail;
  if (typeof detail === 'string') return detail;
  if (Array.isArray(detail)) {
    return detail.map((d) => (d && typeof d.msg === 'string' ? d.msg : JSON.stringify(d))).join(' ');
  }
  if (detail && typeof detail.msg === 'string') return detail.msg;
  return e?.message || 'Something went wrong';
}
